import { Container, Row, Col, Card, Button } from "react-bootstrap";
import imamanwar from "../assets/imamanwar.jpg";
import nueces1 from "../assets/nueces1.jpg";
import MobileFooter from "../components/mobileFooter";
import MobileNavigationBar from "../components/mobileNavbar";
import nuecesbannerM from "../assets/nuecesbannerM.png";

const NuecesMobile = () => {
  return (
    <div className="position-relative">
      <MobileNavigationBar />

      {/* Hero Banner */}
      <div
        style={{
          backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.6) 0%, rgba(64,64,64,0) 90%), url(${nuecesbannerM})`,
          backgroundSize: "cover",
          backgroundPosition: "center 100%",
          height: "25vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <div>
          <h3
            style={{
              fontSize: "24px",
              marginBottom: "6px",
              color: "white",
              textShadow: "1px 1px 2px black",
            }}
          >
            Nueces Mosque Reconstruction
          </h3>
          <p
            style={{
              fontSize: "14px",
              lineHeight: "1.4",
              color: "white",
              textShadow: "1px 1px 2px black",
              margin: "0 auto",
              maxWidth: "92%",
            }}
          >
            Help us build a home for the next generation of Muslims. What starts here changes the Ummah.
          </p>
          <Button
            href="https://www.nuecesmosque.com/reconstruction"
            className="px-3 py-1 mt-3 text-center "
            style={{
              backgroundColor: "#b65f0f",
              color: "white",
              border: "none",
              borderRadius: "5px",
              fontSize: "16px",
            }}
          >
            <h4>Donate Now</h4>
          </Button>
        </div>
      </div>


      <Container className="my-3">
        {/* Legacy */}
        <Row className="text-center mt-3">
          <h3 style={{ fontSize: "20px", marginBottom: "8px" }}>
            A Legacy of Faith and Community
          </h3>
        </Row>
        <Row className="justify-content-center my-2">
          <Col md={10} className="text-center">
            <p style={{ fontSize: "14px", lineHeight: "1.4", marginBottom: 0 }}>
              For more than forty five years, Nueces Mosque has been a home for Muslim students in Austin. From daily prayers, social gatherings and Ramadan iftars, this small yellow house has nurtured generations of leaders, scholars and community members. Now, as the community grows, it is time to build a space that carries this legacy into the future.
            </p>
          </Col>
        </Row>

        <hr className="my-3" />

        {/* Why Nueces Matters */}
        <Row className="align-items-center my-3">
          <Col md={6} className="mb-2">
            <h3 className="mb-2" style={{ fontSize: "20px" }}>
              Why Nueces Matters
            </h3>
            <p style={{ fontSize: "14px", lineHeight: "1.4" }}>
              University is a pivotal time in a young Muslim life. At Nueces, students reconnect with Islam in community. Identities are shaped, friendships are formed and future leaders are nurtured.
            </p>
            <blockquote className="blockquote" style={{ fontSize: "14px", marginBottom: 0 }}>
              <em>
                At Nueces Mosque, we see hundreds of students walk through these doors every year and transform into the best versions of themselves, the best Muslims they can be.
              </em>
              <footer className="blockquote-footer mt-2">Imam Anwar</footer>
            </blockquote>
          </Col>

          {/* Side by side images on mobile */}
          <Col md={6}>
            <Row className="g-2">
              <Col xs={6} className="p-1">
                <img
                  src={imamanwar}
                  alt="Imam Anwar at Nueces"
                  className="img-fluid rounded shadow"
                />
              </Col>
              <Col xs={6} className="p-1">
                <img
                  src={nueces1}
                  alt="Students at Nueces"
                  className="img-fluid rounded shadow"
                />
              </Col>
            </Row>
          </Col>
        </Row>

        <hr className="my-3" />

        {/* Why YOU Should Care */}
        <Row className="justify-content-center my-3">
          <Col md={12}>
            <h3 className="mb-2 text-start" style={{ fontSize: "20px" }}>
              Why Should YOU Care About Nueces
            </h3>
            <p className="text-start" style={{ fontSize: "14px", lineHeight: "1.4" }}>
              This project is bigger than one campus or one city or one generation. The students who walk through these doors today will be tomorrow lawyers, doctors, educators, community organizers and leaders. What they learn here they will carry with them to every corner of the world.
            </p>

            <ul className="text-start" style={{ paddingLeft: "20px", marginBottom: 0 }}>
              <li style={{ fontSize: "14px", marginBottom: "0.7rem" }}>
                <strong>A Legacy Beyond Students:</strong> Whether you are an alum, a parent, a resident of Austin or someone who believes in strengthening the Ummah, Nueces belongs to you. Its impact reaches far beyond UT Austin and shapes Muslim identity and leadership across the nation.
              </li>
              <li style={{ fontSize: "14px", marginBottom: "0.7rem" }}>
                <strong>A Place of Humanitarian Service:</strong> Students and community members actively volunteer, organize drives and serve the Greater Austin community. The mosque is a place of compassion and service.
              </li>
              <li style={{ fontSize: "14px", marginBottom: "0.7rem" }}>
                <strong>Every Act Counts:</strong> Every plate served, every class taught and every prayer made at Nueces is part of a legacy you can share in. Together we can build a space where future generations will thrive.
              </li>
            </ul>

            <blockquote className="blockquote text-start mt-3" style={{ fontSize: "14px", marginBottom: 0 }}>
              <em>
                This is a community like no other in America. A place where the world brightest students come to connect with Islam, gain knowledge and return home as trained leaders.
              </em>
              <footer className="blockquote-footer mt-2">Imam Jawad Rasul</footer>
            </blockquote>
          </Col>
        </Row>

        <hr className="my-3" />

        {/* Stats */}
        <Row className="text-center my-3 g-2">
          <Col xs={4} sm={4}>
            <Card className="h-100 border-success shadow-sm">
              <Card.Body className="d-flex flex-column justify-content-center align-items-center py-3">
                <h4 style={{ color: "#2d4724", fontWeight: "bold", marginBottom: "4px" }}>500+</h4>
                <p style={{ fontSize: "14px", margin: 0 }}>Iftars served daily in Ramadan</p>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={4} sm={4}>
            <Card className="h-100 border-success shadow-sm">
              <Card.Body className="d-flex flex-column justify-content-center align-items-center py-3">
                <h4 style={{ color: "#2d4724", fontWeight: "bold", marginBottom: "4px" }}>45+</h4>
                <p style={{ fontSize: "14px", margin: 0 }}>Years of service</p>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={4} sm={4}>
            <Card className="h-100 border-success shadow-sm">
              <Card.Body className="d-flex flex-column justify-content-center align-items-center py-3">
                <h4 style={{ color: "#2d4724", fontWeight: "bold", marginBottom: "4px" }}>1st</h4>
                <p style={{ fontSize: "14px", margin: 0 }}>The largest student run mosque in the US</p>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <hr className="my-3" />

        {/* Vision Section */}
        <Row className="align-items-center my-3">
          <Col md={7} className="mb-2">
            <h3 style={{ fontSize: "20px", marginBottom: "8px" }}>The Vision for Tomorrow</h3>
            <p style={{ fontSize: "14px", lineHeight: "1.4", marginBottom: 0 }}>
              The new Nueces will be more than a mosque. It will be a hub for students to pray, learn and grow. With housing, classrooms, study spaces and lounges, it will be a sanctuary built by students for students. Every young Muslim will have a safe space to thrive spiritually, intellectually and socially.
            </p>
          </Col>
          <Col md={5} className="text-center">
            <Col md={6} className="text-center">
              <iframe
                src="https://www.youtube.com/embed/R38-NwVUBjk?si=xN_kh2QiFBHvorDd" 
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>

            </Col>

          </Col>
        </Row>


        <hr className="my-3" />

        {/* Mufti Umer Esmail Section */}
        <Row className="text-center my-3 align-items-center">

          <Col xs={12}>
            <h4>Honoring Mufti Umer Esmail (Rahimahullah)</h4>
            <p style={{ fontSize: "14px", lineHeight: "1.4" }}>
              Mufti Umer Esmail was a beloved scholar and imam whose guidance profoundly shaped the UT and Austin Muslim community.
              Serving Nueces Mosque for nearly a decade, he touched the lives of countless students, helping them grow spiritually, intellectually, and personally.
              Known for his humility, compassion, and dedication to both family and community, he embodied the Prophetic example of service to Allah and His creation.
            </p>
            <p style={{ fontSize: "14px", lineHeight: "1.4" }}>
              Though he passed in 2019, his legacy lives on in the students he mentored, the community he nurtured, and the vision for Nueces Mosque that continues to inspire us today.
              Naming the new center in his honor is a tribute to his lifetime of service and enduring impact.
            </p>
            <h5 style={{ fontSize: "16px", marginTop: "10px" }}>
              Honor Mufti Umer’s legacy by helping continue the work he devoted his life to.
            </h5>
          </Col>
          <Col xs={12} className="mb-3">
            <img
              src="https://s.hdnux.com/photos/01/52/37/31/27915882/6/ratio4x3_960.webp"
              alt="Mufti Mohamed-Umer Esmail"
              className="img-fluid rounded shadow"
            />
          </Col>
        </Row>

        <hr className="my-3" />

        {/* Call to Action */}
        <Row className="text-center my-3 mb-4">
          <Col>
            <h3 style={{ fontSize: "20px", marginBottom: "6px" }}>
              Be Part of Building the Future
            </h3>
            <p style={{ fontSize: "14px", lineHeight: "1.4", margin: "0 auto 8px", maxWidth: "95%" }}>
              Support the Nueces Mosque Reconstruction Project. Every dollar you give is an investment in the next generation of Muslims. Together we can create a space that will serve students and the Ummah for generations to come.
              <br />
              <em>
                Whoever builds a Masjid for Allah, Allah will build a home for them in paradise
              </em>
            </p>
            <h4 className="my-3">
              Donate now through Stocks, Zelle, Venmo, Company Matching, Checks, Feeling Blessed, or if you are not ready to donate yet, pledge your support!
            </h4>
            <Button
              href="https://www.nuecesmosque.com/reconstruction#donate"
              className="px-3 py-1 mt-1 text-center text-bold pt-2"
              style={{
                backgroundColor: "#975c17ff",
                color: "white",
                border: "none",
                borderRadius: "5px",
                fontSize: "16px",
              }}
            >
              <h4>Donate Now</h4>
            </Button>
          </Col>
        </Row>
      </Container>

      <MobileFooter />
    </div>
  );
};

export default NuecesMobile;
